var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true)?_c('div',{staticClass:"user__header"},[_c('backlink'),_vm._v(" "),_vm._m(0)],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user__header-title-container"},[_c('img',{attrs:{"src":"/static/img/pictos/compte.svg"}}),_vm._v(" "),_c('span',[_vm._v("Mon compte")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-651b0f58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserHeader.vue
// module id = 533
// module chunks = 0